import { render, staticRenderFns } from "./BackLink.vue?vue&type=template&id=4249562f&scoped=true"
import script from "./BackLink.vue?vue&type=script&lang=js"
export * from "./BackLink.vue?vue&type=script&lang=js"
import style0 from "./BackLink.vue?vue&type=style&index=0&id=4249562f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4249562f",
  null
  
)

export default component.exports